// removed by extract-text-webpack-plugin
module.exports = {"legend":"legend__16Bxb","textLabel":"textLabel__1joTL","exportLegend":"exportLegend__Ubl1L","legendWrapper":"legendWrapper__Vw742","legendColor":"legendColor__3Vlb7","legendDescription":"legendDescription__2fl0B","legendPercentage":"legendPercentage__1XV7M","perc":"perc__2AJLF","textField":"textField__3idj6","contributionText":"contributionText__2WWI2","dollor":"dollor__2DjDI","donut":"donut__1hbgJ","imageWrapper":"imageWrapper__wG9x0","sdg_image":"sdg_image__3iyCd","svgIe":"svgIe__2AJSS"};


//////////////////
// WEBPACK FOOTER
// ./components/projectDonutBarChart/donutChart/style.scss
// module id = ykHf
// module chunks = 0 2